import { render, staticRenderFns } from "./VendedorList.vue?vue&type=template&id=d0cbaf1e&scoped=true&"
import script from "./VendedorList.vue?vue&type=script&lang=js&"
export * from "./VendedorList.vue?vue&type=script&lang=js&"
import style0 from "./VendedorList.vue?vue&type=style&index=0&id=d0cbaf1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0cbaf1e",
  null
  
)

export default component.exports